import { call, put, takeLatest, select } from 'redux-saga/effects';
import { showAPIerror, isEmpty} from '../../pages/SellerProfile/APIs/Helpers';
import { apiGetCall, apiPutCall } from '../api';
import {
  fetchCredentialTypesSuccess,
  fetchCredentialTypesFailure,
  fetchCredentialTypes,
  fetchAllApiCredentialFailure,
  fetchAllApiCredentialStart,
  fetchAllApiCredentialSuccess,
  // setApiCredTypes,
  updateApiCredentialsFailure,
  updateApiCredentialsStart,
  updateApiCredentialsSuccess,
  setSuccessUpdating,
} from '../slices/apiCredentialSlice';
import axios from 'axios';
import { InteractionRequiredAuthError } from '@azure/msal-browser';
import { setApiStatus,setShowSuccessPopUp } from '../slices/sellerProfileSlice';


const URL = process.env.REACT_APP_API_BASE;
function* checkTokenExpired() {
  // if (jwtDecode(token).exp < Date.now() / 1000) {
  yield (window.instance as any)
    .acquireTokenSilent({
      redirectUri: process.env.REACT_APP_AZURE_REDIRECT,
      authority: process.env.REACT_APP_AZURE_AUTHORITY
    })
    .then((res) => {
      axios.defaults.headers.common['Authorization'] = `Bearer ${res.idToken}`;
    })
    .catch((e) => {
      if (e instanceof InteractionRequiredAuthError) {
        (window.instance as any).loginRedirect();
      }
    });
}
function* SpAPIgetApiCredTypesSaga(action) {
  try {
    yield call(checkTokenExpired);
    const response = yield call(apiGetCall, URL + 'credential-types');
    yield put(fetchCredentialTypesSuccess(response));
    return response
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(fetchCredentialTypesFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'fetchNotificationTypesSaga')
    ));
  }
}

function* SpAPIgetAllApiCredsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { apiCredTypes } = yield select((state) => state.apiCredential);
    const { seller_id, users } = yield select((state) => state.sellerProfile);
    const language = action.payload.language;
    let useApiCredTypes = apiCredTypes;
    if (isEmpty(apiCredTypes)) {
      const credTypes = yield call(SpAPIgetApiCredTypesSaga, action);
      if (credTypes) {
        // yield put(setApiCredTypes(credTypes));
        useApiCredTypes = credTypes || [];
      }
    }
    const response = yield call(apiGetCall, URL + 'api-credentials-contacts/' + seller_id);
    if (response) {
      yield put(fetchAllApiCredentialSuccess({
        usersData: response.data.user,
        language: language,
        useApiCredTypes: useApiCredTypes,
        users: users
      }));
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(fetchAllApiCredentialFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpAPIgetAllApiCreds - get usercreds')))
  }
}

function* updateApiCredsSaga(action) {
  try {
    yield call(checkTokenExpired);
    const { apiCredTypes } = yield select((state) => state.apiCredential);
    const { language, formUpdates, curr_user_id } = action.payload;
    let useApiCredTypes = apiCredTypes;
    const credential_type_id = language === 'fr'
      ? 'credentials_type_fr'
      : 'credentials_type_en';
    if (isEmpty(apiCredTypes)) {
      const credTypes = yield call(SpAPIgetApiCredTypesSaga, action);
      if (credTypes) {
        //yield put(setApiCredTypes(credTypes))
        useApiCredTypes = credTypes || [];
      }
    }
    const sendUpdatesContent: any[] = [];
    useApiCredTypes.forEach((t) => {
      const update = {
        credential_type_id: t.credentials_type_id,
        active: formUpdates['editAPIcreds'].env.content.includes(
          t[credential_type_id]
        )
      };
      sendUpdatesContent.push(update);
    });
    const sendUpdates = { data: sendUpdatesContent };
    //get all User info from DB again to ensure we have the most up to date info
    const response = yield call(apiPutCall, URL + 'api-credentials-contact/' + curr_user_id, sendUpdates);
    if (response.data.message === 'Successful') {
      yield call(SpAPIgetAllApiCredsSaga, action)
      yield put(updateApiCredentialsSuccess(response));
      yield put(setSuccessUpdating(true));
    }
  } catch (error: any) {
    const {spPageText} = yield select(({ sellerProfile: { spPageText } }) => ({ spPageText }));
    yield put(updateApiCredentialsFailure(showAPIerror(error, spPageText,setShowSuccessPopUp,setApiStatus, 'SpApiUpdateAPIcreds')));
  }
}

export default function* apiCredentialSaga() {
  yield takeLatest(fetchCredentialTypes.type, SpAPIgetApiCredTypesSaga);
  yield takeLatest(fetchAllApiCredentialStart.type, SpAPIgetAllApiCredsSaga);
  yield takeLatest(updateApiCredentialsStart.type, updateApiCredsSaga);
}